export const ALERT_PRODUCED_QUANTITY = "QUANTITA PRODOTTA";
export const CHECK_TO_INSERT = "CONTROLLO DA INSERIRE";
export const ALERT_TYPE_WARNING = "warning";